class HbsHastaMuayeneSablonDTO {
    id: number = null;
    servisveriId?: number = null;
    bransId?: number = null;
    adi?: string = "";
    ortaksablon?: string = "E";
    sablon?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
}
export default HbsHastaMuayeneSablonDTO;